/** The one resolution function used by both client and server (§35, superseding
 * §34.1's D-34-02): every vehicle - catalog default, workspace override, or
 * custom - always carries its own L1/L2/L3 disassembly minutes, so this is a
 * straight fold with no shop-wide profile fallback. L0 is always 0 (never
 * stored). */
export function resolveDisassemblyMinutesByLevel(args) {
    return {
        L0: 0,
        L1: args.vehicleL1Minutes,
        L2: args.vehicleL2Minutes,
        L3: args.vehicleL3Minutes,
    };
}
/** Folds a resolved wrap pricing profile + vehicle/coverage selection into a
 * WrapPricingInput, matching the mapping proven correct in WrapTab.tsx's
 * LiveExamplePanel and VehicleAwareWrapLineBuilder.tsx. */
export function buildWrapPricingInput(args) {
    return {
        laborRateCentsPerHour: args.laborRateCentsPerHour,
        designRateCentsPerHour: args.designRateCentsPerHour,
        wasteBp: args.wasteBp,
        markupBp: args.markupBp,
        costPerFtCents: args.costPerFtCents,
        vehicleBaseFtX10: args.vehicleBaseFtX10,
        vehicleBaseMinutes: args.vehicleBaseMinutes,
        complexityBp: args.complexityBp,
        coverage: args.coverage,
        modifiers: args.modifiers,
        modifierDefs: args.modifierDefs,
        finishKey: args.finishKey,
        finishDefs: args.finishDefs,
        disassemblyLevel: args.disassemblyLevel,
        disassemblyMinutesByLevel: args.disassemblyMinutesByLevel,
        doorJambs: args.doorJambs,
        jambsFtX10: args.jambsFtX10,
        jambsMinutes: args.jambsMinutes,
        defectPanelCount: args.defectPanelCount,
        defectMinutesPerPanel: args.defectMinutesPerPanel,
        correctionFeeCents: args.correctionFeeCents ?? 0,
        removalTier: args.removalTier,
        removalMinutesByTier: args.removalMinutesByTier,
        designMinutes: args.designMinutes ?? 0,
        printCostCents: args.printCostCents ?? 0,
        fixedAddOnCents: args.fixedAddOnCents ?? 0,
    };
}
/** Folds a PPF zone def + resolved material tier cost into a PpfPricingInput. */
export function buildPpfPricingInput(args) {
    return {
        zoneSqftX10: args.zoneSqftX10,
        zoneMinutes: args.zoneMinutes,
        cureHoldMinutes: args.cureHoldMinutes,
        costPerSqftCents: args.costPerSqftCents,
        designMinutes: args.designMinutes ?? 0,
        fixedAddOnCents: args.fixedAddOnCents ?? 0,
    };
}
//# sourceMappingURL=build-input.js.map